import { Plugin } from './Plugin';
import { GlobalsPlugin } from './GlobalsPlugin';
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';

export class FXAAPlugin extends Plugin{
	constructor(manager){
		super(manager);



		this.fxaa = new ShaderPass( FXAAShader );

		this.viewer.rendering.disableRenderPass = false;
		this.viewer.rendering.customPasses.add(this.fxaa);

	}

	attach(){
		this.viewer.on('resize', this.onResize);
	}

	detach(){
		this.viewer.off('resize', this.onResize);
	}

	onResize = () => {

		const pixelRatio = this.viewer.rendering.renderer.getPixelRatio();
		this.fxaa.material.uniforms[ 'resolution' ].value.x = 1 / ( this.viewer.width * pixelRatio );
		this.fxaa.material.uniforms[ 'resolution' ].value.y = 1 / ( this.viewer.height * pixelRatio );

	}

	update(){
		this.manager.get(GlobalsPlugin).antialias = false;
	}
}